import { useState } from 'react'

import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import { Container } from '@twistopayments/design-system/components/atoms/container'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { SectionsMediaArticleListComponent } from '@twisto/api-cms'

import { useAdditionalData } from 'homepage/libs/context'

import { HighlightedTitle } from '../../molecules/highlighted-title'

import { MediaArticleListItem } from './media-article-list-item'
import * as styles from './media-articles-list.styles'

const DEFAULT_VISIBLE_ITEMS = 4
export const MediaArticlesList = ({
  title,
  initialVisibleItems = DEFAULT_VISIBLE_ITEMS,
  showLessBtnText,
  showMoreBtnText,
  highlighted,
}: SectionsMediaArticleListComponent) => {
  const { mediaArticlesData } = useAdditionalData()
  const [isOpened, setIsOpened] = useState(false)
  const toggle = () => setIsOpened((prevState) => !prevState)

  const visibleArticles = isOpened
    ? mediaArticlesData
    : mediaArticlesData?.slice(0, initialVisibleItems)

  return (
    <Container size="large">
      <HighlightedTitle
        align="center"
        highlighted={highlighted}
        title={title}
      />

      {visibleArticles && (
        <>
          <ul css={styles.container}>
            {visibleArticles.map((article) => (
              <MediaArticleListItem key={article.id} {...article} />
            ))}
          </ul>

          {mediaArticlesData &&
            mediaArticlesData.length > initialVisibleItems && (
              <Typography align="center">
                <TextButton onClick={toggle}>
                  {isOpened ? showLessBtnText : showMoreBtnText}
                </TextButton>
              </Typography>
            )}
        </>
      )}
    </Container>
  )
}
